import styled, { css } from 'styled-components';
import { media } from '../../../helper/styleHelper';
import { key } from 'styled-theme';

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const TooltipTarget = styled.button`
  position: relative;
  border: none;
  background: inherit;
  padding: 5px;
  margin: 4px;
  font: normal normal normal 20px/19px Space Grotesk Regular;
  color: inherit;
  display: flex;
  align-items: center;
  gap: ${key('sizes.gap.normal', '25px')};
  cursor: pointer;
  ${({ showOnFocus }) =>
    !showOnFocus &&
    css`
      outline: none;
    `};
`;

export const CenterContainer = styled.div`
  position: absolute;
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '-169px')};
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  bottom: calc(100% + 5px);
  pointer-events: none;

  ${({ position }) => {
    switch (position) {
      case 'bottom':
        return css`
          bottom: unset !important;
          top: calc(100% + 5px);
        `;
      case 'left':
        return css`
          margin-right: 0;
          width: 100%;
          left: unset;
          top: 50%;
          right: calc(100% + 5px);
          width: max-content;
        `;
      case 'right':
        return css`
          margin-left: 0;
          width: 100%;
          top: 50%;
          left: calc(100% + 5px);
          width: max-content;
        `;
      default:
        return css`
          bottom: calc(100% + -4px);
        `;
    }
  }}
`;

export const TooltipBox = styled.span`
  width: ${(props) => (props.width ? props.width : '150px')};
  max-width: 100%;
  position: relative;
  background-color: #${(props) => (props.background ? props.background : 'fff')};
  color: #fff;
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')};
  border-radius: ${(props) => (props.borderRadius ? props.borderRadius : '5px')};
  padding: ${(props) => (props.padding ? props.padding : '20px')};
  font-size: 1.25rem;
  box-shadow: ${(props) => (props.shadow ? props.shadow : '0px 0px 30px #71717129')};
  border: 1px solid #${(props) => (props.borderColor ? props.borderColor : '717171')};
  opacity: 1;
  z-index: 100;
  ${media.md`
     width: ${(props) => (props.width ? props.width : '350px')};
    `}
  ${({ position }) => {
    switch (position) {
      case 'right':
        return css`
          color: #000;
        `;
      case 'bottom':
        return css`
          &::before {
            content: '';
            position: absolute;
            width: 11px;
            height: 11px;
            border-width: 1px 0px 0px 1px;
            border-style: solid;
            border-color: #717171;
            background-color: #fff;
            top: -7px;
            left: 50%;

            transform: rotate(45deg);
          }
        `;
      case 'top':
        return css`
          &::before {
            content: '';
            position: absolute;
            width: 11px;
            height: 11px;
            border-width: 1px 0px 0px 1px;
            border-style: solid;
            border-color: #717171;
            background-color: #fff;
            bottom: -7px;
            left: 50%;

            transform: rotate(223deg);
          }
        `;
      default:
        return css``;
    }
  }}

 

  ${({ position }) => {
    switch (position) {
      case 'bottom':
        return css`
          &:after {
            border-color: transparent transparent #${(props) => props.background} transparent;
            top: unset;
            width: 1px;
            bottom: 100%;
            left: calc(50% - 5px);
          }
        `;
      case 'left':
        return css`
          &:after {
            border-color: transparent transparent transparent #${(props) => props.background};
            left: 100%;
            top: calc(50% - 5px);
          }
        `;
      case 'right':
        return css`
          &:after {
            border-color: transparent #${(props) => props.background} transparent transparent;
            right: 100%;
            left: unset;
            top: calc(50% - 5px);
            position: absolute;
            content: '';
            border-top: 0px solid #${(props) => (props.borderColor ? props.borderColor : '717171')};
            border-left: 1px solid #${(props) => (props.borderColor ? props.borderColor : '717171')};
            border-right: 0px solid #${(props) => (props.borderColor ? props.borderColor : '717171')};
            border-bottom: 1px solid #${(props) => (props.borderColor ? props.borderColor : '717171')};

            transform: rotate(45deg);
            width: 15px;
            height: 15px;
            top: 100%;
            background-color: #${(props) => (props.background ? props.background : 'fff')};
            right: 100%;
            left: -9px;
            top: calc(50% - 5px);
          }
        `;
      default:
        return css``;
    }
  }}
`;
